module.exports = __webpack_public_path__ + "static/img/order_empty.1217e143.png";